module.exports = __webpack_public_path__ + "img/picture_25.b768e633.png";